import { render, staticRenderFns } from "./AccountInfobox.html?vue&type=template&id=31e2184c&scoped=true&"
import script from "./AccountInfobox.ts?vue&type=script&lang=ts&"
export * from "./AccountInfobox.ts?vue&type=script&lang=ts&"
import style0 from "./_infobox.scss?vue&type=style&index=0&id=31e2184c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e2184c",
  null
  
)

export default component.exports